import { useEffect, useState } from "react";
import axios from "axios";

export const api = axios.create({
  baseURL: `${process.env.REACT_APP_BACKEND_URL}/api`,
});

export const money = (m) => {
  if (!m) return "";
  const amt = parseFloat(m.amount);
  try {
    return new Intl.NumberFormat("en-US", {
      style: "currency",
      currency: m.currencyCode || "USD",
      minimumFractionDigits: Number.isInteger(amt) ? 0 : 2,
    }).format(amt);
  } catch {
    return `$${m.amount}`;
  }
};

export function useProducts(params = {}) {
  const [state, setState] = useState({ loading: true, connected: true, products: [] });
  const key = JSON.stringify(params);
  useEffect(() => {
    let active = true;
    setState((s) => ({ ...s, loading: true }));
    api
      .get("/products", { params })
      .then((r) => {
        if (active)
          setState({
            loading: false,
            connected: r.data.connected,
            products: r.data.products || [],
          });
      })
      .catch(() => {
        if (active) setState({ loading: false, connected: true, products: [] });
      });
    return () => {
      active = false;
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [key]);
  return state;
}

const RECENT_KEY = "tn-recent";

export const getRecent = () => {
  try {
    return JSON.parse(localStorage.getItem(RECENT_KEY)) || [];
  } catch {
    return [];
  }
};

export const pushRecent = (p) => {
  const list = getRecent().filter((x) => x.handle !== p.handle);
  list.unshift({
    handle: p.handle,
    title: p.title,
    productType: p.productType,
    image: p.featuredImage?.url,
    price: p.priceRange?.minVariantPrice,
  });
  localStorage.setItem(RECENT_KEY, JSON.stringify(list.slice(0, 8)));
};
